// 共用 Gateway 封包信封的 Protobuf schema — 對應後端權威 gateway_cmd.proto（package Gateway）
// 的 PacketCmd / ResponseInfo 兩則訊息。姊妹專案 pixi_slot（FaFaCat 移植案）已對這份 schema
// 完成實機驗證；本專案 CLAUDE.md 已確認 Slot026 與 FaFaCat 共用同一個 Gateway
// （`SlotFramework/Network/ServerSetting.asset` 連線位址完全相同），故此信封層可直接沿用。
//
// 與姊妹專案的實作差異：姊妹專案以 vite `?raw` 載入完整的後端 .proto 原始檔（含本專案尚未
// 取得的 gateway_login/gateway_gameinfo/... 等遊戲階段訊息）。本專案尚未取得那些檔案，
// 也不確認 Slot026 專屬的 Protobuf 欄位（見 docs/PROTOBUF_SCHEMA.md），所以改用 protobufjs
// 的 Reflection API 直接在程式碼中宣告「僅信封層」的最小 schema，不依賴任何 .proto 來源檔、
// 不引入任何遊戲專屬訊息型別。欄位名稱使用 camelCase（wire 相容性只取決於欄位編號與型別，
// 與欄位名稱字串無關），欄位編號與型別逐一對應 gateway_cmd.proto 原文。
//
// 尚未接上本專案（Slot026）的真實後端，欄位版面未經本專案實機驗證。
import * as protobuf from 'protobufjs'

export const PacketCmdType = new protobuf.Type('PacketCmd')
  .add(new protobuf.Field('cmd', 1, 'string'))
  .add(new protobuf.Field('requestId', 2, 'string'))
  .add(new protobuf.Field('data', 3, 'bytes'))

export const ResponseInfoType = new protobuf.Type('ResponseInfo')
  .add(new protobuf.Field('code', 1, 'int32'))
  .add(new protobuf.Field('message', 2, 'string'))
  .add(new protobuf.Field('cmd', 3, 'string'))
  .add(new protobuf.Field('requestId', 4, 'string'))
  .add(new protobuf.Field('txnId', 5, 'string'))
  .add(new protobuf.Field('balance', 6, 'uint64'))
  .add(new protobuf.Field('currency', 7, 'string'))
  .add(new protobuf.Field('data', 8, 'bytes'))
  .add(new protobuf.Field('totalWin', 9, 'uint64'))

new protobuf.Root().add(PacketCmdType).add(ResponseInfoType)
